import React from 'react';

const logoUrl = 'https://customer-assets.emergentagent.com/job_workflow-hub-368/artifacts/fp565w6h_Capture.png';

export const TechOrangeWorkspaceHeader = ({ title, subtitle, identity, children }) => {
  return <header className="sticky top-0 z-30 border-b border-slate-200 bg-white text-slate-900" data-testid="techorange-brand-header">
    <div className="flex min-h-16 flex-wrap items-center justify-between gap-4 px-4 py-3 sm:min-h-20 sm:px-6">
      <div className="flex min-w-0 items-center gap-3 sm:gap-4">
        <div className="flex h-9 shrink-0 items-center rounded-[9px] bg-[#1A1A6C] px-2 sm:h-10" data-testid="techorange-brand-logo">
          <img src={logoUrl} alt="TechOrange" className="h-5 w-auto select-none object-contain sm:h-6" />
        </div>
        <div className="min-w-0">
          <h1 className="text-base font-semibold leading-tight sm:text-lg" data-testid="workspace-header-title">{title}</h1>
          {subtitle ? <p className="mt-1 truncate text-xs text-slate-500" data-testid="workspace-header-subtitle">{subtitle}</p> : null}
        </div>
      </div>
      <div className="flex items-center gap-2 sm:gap-3">
        {identity ? <div className="hidden text-right sm:block" data-testid="workspace-header-identity">{identity}</div> : null}
        {children}
      </div>
    </div>
  </header>;
};